
export function useNumberFormat() {
    const formatNumber = (number, fractionDigits= 2) => {
        return new Intl.NumberFormat('fa-IR', {maximumFractionDigits: fractionDigits}).format(number);
    };

    return { formatNumber };
}
